import * as React from 'react';

import { ResidenceCardData } from 'features/search/types';
import { HeadlineLevel } from 'features/ui/enums';
import { getLocalizedRok } from 'features/services/utils/env-helper';

import { ContentTemplate } from './_contentTemplate';
import { getFormattedMessage } from 'features/services/utils/language-helper';

interface Props {
    residence: ResidenceCardData;
    level?: HeadlineLevel;
}

export const RentalContent: React.FunctionComponent<Props> = ({ residence, level }) => {
    let description = getFormattedMessage('jm.components.ResidenceTags.tenacy');
    
    const shouldRender = (min, max) => {
        if(typeof min === 'undefined' || min === null) return false;
        if(typeof max === 'undefined' || max === null) return false;
        if(min === 0) return false;
        if(max === 0) return false;

        return true;
    };

    const getDescription = () => {
        if(shouldRender(residence.minRooms, residence.maxRooms)) {
            description += ' • ';
            description += residence.minRooms === residence.maxRooms 
                ? getLocalizedRok(residence.minRooms)
                : residence.minRooms + ' - ' + getLocalizedRok(residence.maxRooms);
        }

        return description;
    }
    
    return (
        <ContentTemplate 
            residenceData={residence} 
            headline={residence.displayName} 
            firstPrice='' 
            secondPrice=''
            description={getDescription()}
            level={level}
        />
    )
}